import { ReportingObserver } from "@sentry/integrations";
import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.FUNDAMENTEI_ENV,
  enabled: true,
  integrations: (integrations) => [...integrations, new ReportingObserver()],
  // See: https://docs.sentry.io/platforms/javascript/performance/
  tracesSampleRate: 0.1,
  ignoreErrors: [
    /Hydration failed/i,
    /There was an error while hydrating/i,
    /Text content does not match server-rendered HTML/i,
    /You're not allowed to perform this operation/i,
    /You're not allowed to perform this action/i,
    /This asset is already in your portfolio/i,
    /You're not authorized/i,
  ],
});
